import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/api.service';
import { Observable } from 'rxjs';

export class OpsToken {
  token: string;
}

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  constructor(private apiService: ApiService) {}

  createOpsToken(): Observable<any> {
    return this.apiService.post('/api/v2/patient/ops_token', {});
  }
}
